import { Stepper as MuiStepper, type StepperProps, styled } from '@lingoda/ui';

const StepperStyled = styled(MuiStepper)(({ theme }) => ({
    background: theme.palette.gradients.primaryToPink,
}));

export const Stepper = ({ connector, alternativeLabel, ...props }: StepperProps) => (
    <StepperStyled connector={null} alternativeLabel {...props} />
);
